import React, { FC } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FiltersNameEnum } from '../../../shared/types';
import { FormItem } from '../../../shared/styles';
import { BookedOutDate } from '../../../FilterCollection';
import { FilterDrawerType, FiltersCategoryNameEnum } from '../../shared/types';
import { useFiltersLabel } from '../../shared/hooks/useFiltersLabel';

interface Props {
  type: FilterDrawerType;
}

const BookedOutDatesCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { isCategoryMatchedSearch } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.bookedOutDates);

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <BookedOutDate
          dateRangeName={FiltersNameEnum.excludeBookedOutDates}
          dateRangeMinName={FiltersNameEnum.min}
          dateRangeMaxName={FiltersNameEnum.max}
          label={filtersLabelOfAudience[FiltersNameEnum.excludeBookedOutDates]}
        />
      </FormItem>
    )
  );
};

export default BookedOutDatesCategory;
